import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import SelectField from 'containers/components/Fields/Select';
import { getLiteral } from 'utils/getLiteral';

const ALL_OWNERS_VALUE = 'all';

class CampaignDetailOwnerFilter extends PureComponent {
    state = {};

    onChange = (value) => {
        this.props.onChange(value === ALL_OWNERS_VALUE ? null : value);
    };

    getOwners = () => {
        let { data } = this.props;

        let owners = new Set();
        let allLiteral = getLiteral('label_campaigns_all_account_owners');
        let ownersItems = [
            {
                value: ALL_OWNERS_VALUE,
                label: allLiteral,
            },
        ];

        data &&
            data.forEach((item) => {
                if (owners.has(item.salesRepId)) return;
                else owners.add(item.salesRepId);
                ownersItems.push({
                    value: item.salesRepId,
                    label: item.salesRepName,
                });
            });
        return ownersItems;
    };

    render() {
        const { owner } = this.props;
        const selectValue = owner == null ? ALL_OWNERS_VALUE : owner;

        return (
            <div className="campaign-detail-owner-filter">
                <SelectField
                    label={getLiteral('label_account_owner')}
                    labelMode="horizontal"
                    onChange={this.onChange}
                    options={this.getOwners()}
                    value={selectValue}
                    usePlainValue
                    isClearable={false}
                    isFullWidth={false}
                />
            </div>
        );
    }
}

CampaignDetailOwnerFilter.propTypes = {
    onChange: PropTypes.func,
    owner: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    data: PropTypes.array,
};

export default CampaignDetailOwnerFilter;
